import { render, staticRenderFns } from "./LegendSelectorAntV.vue?vue&type=template&id=fcf9012e&scoped=true&"
import script from "./LegendSelectorAntV.vue?vue&type=script&lang=js&"
export * from "./LegendSelectorAntV.vue?vue&type=script&lang=js&"
import style0 from "./LegendSelectorAntV.vue?vue&type=style&index=0&id=fcf9012e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf9012e",
  null
  
)

export default component.exports